// @flow
export const webURL = {
  landing: {
    loginAdmin: '/login'
  },
  home: '/'
}
export const adminURL = {
  home: '/',
  companies: {
    index: '/companies',
    edit: '/companies/:id/edit',
    detail: '/companies/:id/detail'
  },
  accountManagers: {
    index: '/accountmanagers',
    edit: '/accountmanagers/:id/edit'
  },
  clients: {
    index: '/clients',
    edit: '/clients/:id/edit'
  }
}

export const ICON_SIZE_MEDIUM = 15
export const ICON_SIZE_LARGE = 45
export const ICON_SIZE_FOR_TRANSACTION_MEDIUM = 40
export const ICON_SIZE_FOR_TRANSACTION_SMALL = 18
export const LIMIT_PER_PAGE = 10
export const DEFAULT_COUNTRY_ABBREVIATION = 'VN'
export const DEFAULT_CURRENCTY = 'USD'
